"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultPortalId = void 0;
var defaultPortalId = exports.defaultPortalId = 'tooltip-portal';